import {
    Input,
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
    Switch,
    Textarea,
} from '@repo/shadcn';
import { Controller, useFormContext } from 'react-hook-form';

import { DynamicFieldData } from '@/types/dynamic-control-types';

import { AutoComplete } from '../components/ui/autocomplete/auto-complete';

export const DynamicControl = ({
    inputType,
    fieldName,
    defaultValue,
    label,
    options = [],
    config = {},
    control,
    className = '',
}: DynamicFieldData) => {
    const { register, control: formControl } = useFormContext();

    switch (inputType) {
        case 'text':
            return (
                <Input
                    type="text"
                    className={`input ${className}  `}
                    {...register(fieldName, config)}
                    defaultValue={defaultValue}
                    placeholder={label}
                />
            );
        case 'password':
            return (
                <Input
                    type="password"
                    className={`${className} input`}
                    {...register(fieldName, config)}
                    defaultValue={defaultValue}
                    placeholder={label}
                />
            );
        case 'text-area':
            return (
                <Textarea
                    className={`${className} input`}
                    {...register(fieldName, config)}
                    defaultValue={defaultValue}
                    placeholder={label}
                />
            );

        case 'select':
            return (
                <Controller
                    name={fieldName}
                    control={control || formControl}
                    defaultValue={defaultValue}
                    render={({ field }) => (
                        <Select {...field}>
                            <SelectTrigger className="w-full">
                                <SelectValue
                                    className=" capitalize"
                                    placeholder="Select options..."
                                />
                            </SelectTrigger>
                            <SelectContent>
                                {options?.map((option, index) => (
                                    <SelectItem
                                        className=" px-3 capitalize"
                                        key={index}
                                        value={option.value}
                                    >
                                        {option.label}
                                    </SelectItem>
                                ))}
                            </SelectContent>
                        </Select>
                    )}
                />
            );

        case 'number':
            return (
                <Input
                    type="text"
                    className={`${className} input`}
                    {...register(fieldName, config)}
                    defaultValue={defaultValue}
                    placeholder={label}
                />
            );

        case 'auto-complete':
            return (
                <Controller
                    name={fieldName}
                    control={control || formControl}
                    defaultValue={defaultValue}
                    render={() => (
                        <AutoComplete
                            control={control || formControl}
                            name={fieldName}
                            options={options || []}
                        />
                    )}
                />
            );
        case 'checkbox':
            return (
                <Controller
                    name={fieldName}
                    control={control || formControl}
                    defaultValue={defaultValue}
                    render={() => <Switch {...register(fieldName, config)} />}
                />
            );

        default:
            return <input type="text" {...register(fieldName, config)} />;
    }
};
